import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsSchemaRoute: InvariantJiraRoute = {
	name: 'assets-schema',
	path: '/jira/assets/object-schema/:objectSchemaId',
};
